import React from 'react'
import PropTypes from 'prop-types'
import Svg from '../shared/Svg'

const Dott = ({fill}) => (
  <Svg width="17" height="17" viewBox="0 0 17 17">
    <g transform="translate(0.000000,16.000000) scale(0.100000,-0.100000)" stroke="none">
      <path
        d="M25 135 c-40 -39 -32 -96 16 -120 40 -21 66 -19 94 10 50 49 15 135 -55 135 -19 0 -40 -9 -55 -25z m95 -15 c28 -28 26 -66 -6 -86 -55 -37 -117 25 -80 80 20 32 58 34 86 6z"/>
      <path className="dot" d="M57 103 c-14 -13 -7 -43 12 -53 28 -14 55 13 41 41 -10 19 -40 26 -53 12z"/>
    </g>
  </Svg>
)


Dott.defaultProps = {
  fill: '#000',
}

Dott.propTypes = {
  fill: PropTypes.string,
}
export default Dott
